import { useState } from "react";
import { connect } from "react-redux";
import stateMap from "store/stateMap";
import { SetUser,SetLookingUser, SetTokenizeUser } from "../../store/dispatcher";
import Consumer from "../Fancybox/FancyboxContext";
import { popinfo } from "../Fancybox/Fancybox";
import "./LoginBox.scss";
import "../../sass/form/form.scss";
import msGraph, { MSGraphAuthenticator } from '../../msal';
import api from '../../api';
import store from "store/store";

const RefreshAzureToken = (azureAccessToken, azureAccessExpires) => {
    return new Promise((resolve, reject) => {

        api('/Account/365', 'post', {
            access_token    : azureAccessToken
            ,expires        : azureAccessExpires
            ,base_url       : store.getState().config.base_url + '/registration'
        })
            .then(response => {
                store.dispatch({
                    type: 'auth/setUser'
                    ,payload: response.user.AccessToken
                })

                resolve(response);
            })
            .catch(error => {
                reject(error);
            })
    });
}


const CallLoginInteraction = () => {
    let Authenticator = new MSGraphAuthenticator();

    return new Promise((resolve, reject) => {
        Authenticator.getToken()
                .then(((response) => {
                    
                    RefreshAzureToken(response.accessToken, (response.expiresOn.getTime() / 1000))
                            .then(function(CrowdbeesToken){
    
                                if(CrowdbeesToken.url)
                                {
                                    window.localStorage.setItem('crowdbees-reg-deep-link', window.location.href);
    
                                    window.location.href = CrowdbeesToken.url;
                                }
                                else
                                {
                                    api('/Account/Token', 'post', {
                                        token : CrowdbeesToken.user.AccessToken
                                    })
                                        .then(function(ResponseToken){
                                            
                                            resolve(ResponseToken.user);

                                        });
                                }
                            })
                            .catch(function(error){
                                reject(error);
                            })
    
                        
                    }).bind(this)).catch(error => {
                        reject(error);
                    })
                .catch(error => {
                    var isPopupBlocked = error.indexOf('popup_window_error') > 0;
    
                    var err = isPopupBlocked ? 'Please allow popup in your browser' : error;

                    reject(err);
                })
    })

}

export {RefreshAzureToken, CallLoginInteraction}

export default connect(stateMap, {SetUser, SetLookingUser, SetTokenizeUser})(function LoginBox(props){ 

    const LoginUser = (e, currentBox) => {
        e.preventDefault();

        let loaderBox = popinfo('loader', 'Logging You In', 'Wait a sec...');

        return CallLoginInteraction()
            .then((user) => {
                loaderBox.close();
                                                    
                props.SetTokenizeUser(user);

                if(currentBox)
                {
                    currentBox.close();
                }
            })
            .catch((error) => {
                popinfo('error', 'Logging You In', error, null, loaderBox);

                props.SetUser('');

                props.SetLookingUser(false);

                props.SetTokenizeUser(false);

            });        
    }

    
    return(
        <Consumer>
            {function(fancybox){
                return(
                    <div id="login-box" style={{ width : '300px'}} className="text-center">
                        <div  className="image-box crowdbees-logo mx-auto mb-md">
                            <img src={process.env.PUBLIC_URL + '/assets/image/logo-crowdbees-orange.png'} alt="" />    
                        </div>

                        <div className="leading-relaxed text-sm mb-lg">
                            Welcome to Crowdbees, discover the best initiatives and talents at BINUS UNIVERSITY
                        </div>

                        <button className="shadow border-solid" style={{borderRadius : '6px', height: '46px'}} onClick={(e) => {
                            LoginUser(e, fancybox);
                        }}>
                            <img src={process.env.PUBLIC_URL + '/assets/image/ms-login.png'} alt="Sign in with Microsoft"   />
                        </button>
                    </div>
                )
            }}
        </Consumer>
    )
}) 